import type { Contact } from '../../models/Contact';
import type { PersonaInfo } from '../../models/PersonaInfo';

type ListContactsRespType = {
    value: Contact[];
};

const PERSONA_ID_KEY = 'PrsId';
const OBJECT_ID_KEY = 'OID';

function extractIdsFromContact(alternateIds: string[]): string[] {
    const personaId = alternateIds
        .map(id => id.split(':'))
        .filter(id => id[0] === PERSONA_ID_KEY)[0]?.[1];

    // OID format - <aadObjectID>@<tenantID> - extract aadObjectID
    const aadObjectId = alternateIds
        .map(id => id.split(':'))
        .filter(id => id[0] === OBJECT_ID_KEY)[0]?.[1]
        .split('@')?.[0];

    return [personaId, aadObjectId];
}

export function convertContactToPersonType(contact: Contact): PersonaInfo {
    const currentPosition = contact.positions?.filter(position => position.isCurrent)?.[0];
    const currentCompany = currentPosition?.detail?.company;
    const mainEmailAddress = contact?.emails?.[0];
    const mainPhoneNumber = contact?.phones?.[0];
    const [personaId, aadObjectId] = extractIdsFromContact(contact.alternateIds);

    return {
        personaId,
        hubPersonaId: `HubContactId_${contact.id}`,
        type: 1,
        isReadOnly: false,
        info: {
            allEmailAddresses: contact.emails?.map(email => email.address),
            displayNameLastFirst: [contact.name?.last, contact.name?.middle, contact.name?.first]
                .filter(Boolean)
                .join(' '),
            displayNameFirstLast: [contact.name?.first, contact.name?.middle, contact.name?.last]
                .filter(Boolean)
                .join(' '),
            mainEmailAddress: mainEmailAddress?.address,
            company: currentCompany?.displayName,
            surname: contact.name?.last,
            givenName: contact.name?.first,
            prefix: contact.name?.title,
            generation: contact.name?.suffix,
            phoneNumber: mainPhoneNumber?.number,
            title: currentPosition?.detail?.jobTitle,
            department: currentCompany?.department,
            location: currentCompany?.officeLocation,
            originalDisplayName: contact.name?.displayName || '',
            externalDirectoryObjectId: aadObjectId,
            contactId: contact.id,
        },
    };
}

function responseConverter(resp: ListContactsRespType): PersonaInfo[] | null {
    return resp.value.map(convertContactToPersonType);
}

export default responseConverter;
